import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { Button, ButtonProps } from 'ui-components/common/Button';
import { LinkButton } from 'ui-components/common/LinkButton';

export interface LinkButtonProps extends ButtonProps {
  href: string;
  title?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export const ExternalLinkButton = ({ href, className, title, ...props }: LinkButtonProps) => {
  const client = useClient();
  if (client.isApp) {
    return <Button className={className} onClick={() => DirittoAppBridge.openExternalView(href, title)} {...props} />;
  }

  return <LinkButton href={href} className={className} {...props} target="_blank" />;
};
